import type * as React from 'react';
import { Fragment, useEffect } from 'react';

import type { LANGUAGES } from '@crehana/ts-types';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import { Container, Row } from '@crehana/ui';
import { AuthProvider } from '@crehana/web/ReactContexts/AuthContext';

import Header from './components/Header';
import { CheckoutProvider } from './context/CheckoutContext';
import { StripeProvider } from './context/StripeContext';
import LeftUI from './sections/LeftUI';
import RightUI from './sections/RightUI';

type Props = {
  language: LANGUAGES;
};

const B2BCheckout: React.FC<React.PropsWithChildren<Props>> = ({
  language,
}) => {
  useEffect(() => {
    document.body.style.overflowX = 'hidden';
  }, []);

  return (
    <AuthProvider>
      <CheckoutProvider>
        <StripeProvider language={language}>
          <Fragment>
            <Header />
            <Container>
              <Row className="m-0 sm:m-0 md:m-0">
                <LeftUI />
                <RightUI />
              </Row>
            </Container>
          </Fragment>
        </StripeProvider>
      </CheckoutProvider>
    </AuthProvider>
  );
};

export default B2BCheckout;
